import styled from "styled-components";

const BackButtonContainer = styled.div`
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export { BackButtonContainer };
